import * as z from "zod";

const confirmResendReturnLabelSchema_ = z.object({
  orderId: z.string().nullish(),
  orderEmail: z.string().nullish(),
});
export const ConfirmResendReturnLabelSchema: z.ZodType<ConfirmResendReturnLabel> =
  confirmResendReturnLabelSchema_;
export interface ConfirmResendReturnLabel extends z.infer<
  typeof confirmResendReturnLabelSchema_
> {}
